module.exports = __webpack_public_path__ + "static/img/卡口枪式摄像头,监控,枪式摄像头.2068119.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/卡口枪式摄像头,监控,枪式摄像头.png
// module id = j1OM
// module chunks = 9